import { PaletteMode } from "@mui/material";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../redux/store";

interface SettingState {
  themeMode: PaletteMode;
  openSidebar: boolean;
  authSidebar: boolean;
  driverSidebar: boolean;
  loginGrids: "user" | "compony";
  userLoginTab: "burdenOwner" | "drivers";
  signupGrids: "user" | "company";

  CampanyRegisterStep: "CompanyInfo" | "ManagerInfo" | "ApproveInfo";

  isOpenKeyboard: boolean;
}

const themeMode = localStorage.getItem("themeMode")
  ? JSON.parse(localStorage.getItem("themeMode") || "")
  : "light";

const initialState: SettingState = {
  themeMode: themeMode,
  openSidebar: false,
  authSidebar: false,
  driverSidebar: false,
  loginGrids: "user",
  signupGrids: "user",
  userLoginTab: "drivers",
  CampanyRegisterStep: "ApproveInfo",
  isOpenKeyboard: false,
};

export const settingSlice = createSlice({
  name: "setting",
  initialState,

  reducers: {
    setThemeMode: (state, action: PayloadAction<PaletteMode>) => {
      state.themeMode = action.payload;
      let mode = JSON.stringify(action.payload);
      localStorage.setItem("themeMode", mode);
    },

    setOpenSidebar: (state, action: PayloadAction<boolean>) => {
      state.openSidebar = action.payload;
    },
    setOpenDriverSidebar: (state, action: PayloadAction<boolean>) => {
      state.driverSidebar = action.payload;
    },

    setOpenAuthSidebar: (state, action: PayloadAction<boolean>) => {
      state.authSidebar = action.payload;
    },

    changeLoginType: (state) => {
      state.loginGrids = state.loginGrids === "user" ? "compony" : "user";
    },
    changeSignupType: (state) => {
      console.log(state.signupGrids);

      state.signupGrids = state.signupGrids === "user" ? "company" : "user";
    },
    handleUserLoginTabbar: (
      state,
      action: PayloadAction<"burdenOwner" | "drivers">
    ) => {
      state.userLoginTab = action.payload;
    },
    changeSignupCompanyStep: (
      state,
      action: PayloadAction<"CompanyInfo" | "ManagerInfo" | "ApproveInfo">
    ) => {
      state.CampanyRegisterStep = action.payload;
    },

    toggleKeyboard: (state, action: PayloadAction<boolean>) => {
      state.isOpenKeyboard = action.payload;
    },
  },
});

export const getSettingState = (state: RootState) => state.setting;
export const {
  setThemeMode,
  setOpenSidebar,
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  changeLoginType,
  handleUserLoginTabbar,
  changeSignupType,
  changeSignupCompanyStep,
  toggleKeyboard,
} = settingSlice.actions;

export default settingSlice.reducer;
